import { axiosClient } from "../axios";

export function getAdminRoles() {
  return axiosClient.get("admin-roles");
}
